import React, { Component } from 'react';
import { Icon } from '../icons/AppIcons';
import '../css/action-trace.css';

class ActionTrace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: '',
      kind: 'running',
      steps: [],
      pos: null,
    };
    this.closeTimer = null;
  }

  componentDidMount() {
    window.startActionTrace = ({ title, steps, pos }) => {
      clearTimeout(this.closeTimer);
      this.setState({
        open: true,
        title: title || '',
        kind: 'running',
        pos: pos || null,
        steps: (steps || []).map((step) => ({
          id: step.id,
          icon: step.icon || 'status',
          label: step.label || '',
          detail: step.detail || '',
          state: step.state || 'pending',
        })),
      });
    };

    window.updateActionTrace = (update = {}) => {
      this.setState((prev) => {
        const steps = prev.steps.map((step) => {
          if (update.step && update.step.id === step.id) {
            return { ...step, ...update.step };
          }
          if (Array.isArray(update.steps)) {
            const next = update.steps.find((item) => item.id === step.id);
            return next ? { ...step, ...next } : step;
          }
          return step;
        });
        return {
          title: update.title || prev.title,
          kind: update.kind || prev.kind,
          steps,
        };
      });
    };

    window.closeActionTrace = (delay = 0) => {
      clearTimeout(this.closeTimer);
      if (delay) {
        this.closeTimer = setTimeout(() => this.setState({ open: false }), delay);
        return;
      }
      this.setState({ open: false });
    };
  }

  componentWillUnmount() {
    clearTimeout(this.closeTimer);
    delete window.startActionTrace;
    delete window.updateActionTrace;
    delete window.closeActionTrace;
  }

  render() {
    const { open, title, kind, steps, pos } = this.state;
    if (!open) return null;
    const style = pos
      ? {
          top: pos.top ?? 'auto',
          left: pos.left,
          bottom: pos.bottom ?? 'auto',
        }
      : undefined;

    return (
      <div
        className={`action-trace is-${kind}${pos ? ` is-${pos.placement || 'below'}` : ' is-fallback'}`}
        style={style}
        role="status"
        aria-live="polite"
      >
        <div className="action-trace-head">
          <strong>{title}</strong>
          <button type="button" className="action-trace-close" onClick={() => this.setState({ open: false })}>
            <Icon name="close" size={18} />
          </button>
        </div>
        <div className="action-trace-steps">
          {steps.map((step) => (
            <div key={step.id} className={`action-trace-step is-${step.state}`}>
              <span className="action-trace-icon">
                <Icon name={step.icon} size={18} />
              </span>
              <span className="action-trace-text">
                <span>{step.label}</span>
                {step.detail ? <em>{step.detail}</em> : null}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ActionTrace;
